import React, {Component} from 'react';
import {Col, Icon,Pagination, Row, Drawer, Typography} from 'antd';
import UserCtrl from "../../../../app/UserCtrl";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import BasicSettingWrapper from ".././v2/Settings2";
import getDate from ".././Date";
import DateSvg from ".././DateIcon";
import moment from "moment";
import '.././size.css'
import {FullscreenExitOutlined, FullscreenOutlined} from "@ant-design/icons";
import MediaScreen from ".././v2/MediaScreen";
import publish from "../../../../publish";
import HomeStyle from "../../../../HomeStyle";
import ic_clock from "../../../../img/v6_ic_clock@2x.png"
import ic_setting from "../../../../img/v6_ic_setting@2x.png"
import ic_refresh from "../../../../img/v6_ic_refresh@2x.png"
import ic_fullscreen_open from "../../../../img/v6_ic_fullscreen_open@2x.png"
import ic_fullscreen_close from "../../../../img/v6_ic_fullscreen_close@2x.png"
import v6_pic_tool_bg_left from "../../../../img/v6_pic_tool_bg_left@2x.png"
import v6_pic_tool_bg_right from "../../../../img/v6_pic_tool_bg_right@2x.png"

class Tools6 extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            modalVisible: false,
            fullScreenState: false,
        };
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);

        //https://blog.csdn.net/weixin_48585264/article/details/118189356
        moment.locale('zh-cn',{
            meridiem: function (hour, minute, isLower) {
                const hm = hour * 100 + minute;
                if (hm < 600) {
                    return '凌晨';
                } else if (hm < 900) {
                    return '早上';
                } else if (hm < 1130) {
                    return '上午';
                } else if (hm < 1230) {
                    return '中午';
                } else if (hm < 1800) {
                    return '下午';
                } else {
                    return '晚上';
                }
            }
        });
    }

    showModal() {
        this.setState({
            modalVisible: true
        })
    }

    hideModal() {
        this.setState({
            modalVisible: false
        })
    }

    componentDidMount() {
        document.addEventListener('keydown', this.keyListener);
        document.addEventListener("webkitfullscreenchange", this.fullscreenchange);
        this.props.bindRef(this);
        document.getElementById('fullScreenBtn').click();
        // this.fullScreen();
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.keyListener);
        document.removeEventListener("webkitfullscreenchange", this.fullscreenchange);
        this.props.unBindRef(this);
    }

    refresh = (pointCount) => {
        this.showDate();
    };

    fullscreenchange = () => {
        if (document.webkitIsFullScreen) {
            //全屏后要执行的代码
            if (!this.state.fullScreenState) {
                this.setState({fullScreenState: true})
            }
        } else {
            //退出全屏后执行的代码
            if (this.state.fullScreenState) {
                this.setState({fullScreenState: false})
            }
        }
    };

    keyListener = (e) => {
        if (e.key === 'F11') {
            e.stopPropagation();
            e.preventDefault();
            this.fullScreen();
        }
    };

    // https://blog.csdn.net/dream19921216/article/details/86596408
    fullScreen = () => {
        if (!this.state.fullScreenState) {
            MediaScreen.enter();
        } else {
            MediaScreen.exit();
        }
    };

    showDate = () => {
        const oDiv = document.getElementById("date");
        oDiv.innerHTML = moment(new Date()).format('YYYY年MM月DD日 dddd h:mm A');
    };

    render() {
        const text_color = {color: HomeStyle.toolsTextColor(this.props.homeStyleCode,this.props.venueSetting)};
        // let name = isBeta()?"正心心电遥测平台":"心电遥测中央监护软件";
        let name = "心电遥测中央监护软件";
        return (
            <div className={'header-size'}
                 style={{
                     ...HomeStyle.toolsBackgroundStyle(this.props.homeStyleCode,this.props.venueSetting),
                     position: 'relative',
                     paddingLeft:0
                 }}>

                <div
                     style={{
                         ...text_color,
                         position: 'absolute',
                         left: '50%',
                         top: '50%',
                         transform: 'translate(-50%,-50%)',
                         whiteSpace: 'nowrap',
                         pointerEvents: 'none',
                         display:'flex'
                     }}>
                    <span><img src={v6_pic_tool_bg_left} style={{width:'241px',height:'8px',marginTop:'4px'}} alt={'left'}/></span>
                    <span><div className={'header-date-text-size'}
                        style={{padding:'1px 25px 2px 25px',
                        marginLeft:25,
                        marginRight:25,
                        border:'1px solid #61738B',
                        borderRadius:5}}>{this.props.companyName}</div></span>
                    <span><img src={v6_pic_tool_bg_right} style={{width:'241px',height:'8px',marginTop:'4px'}} alt={'right'}/></span>
                </div>

                <Row gutter={12} type="flex" align="middle" justify="space-between" style={{zIndex: 2}}>
                    <Col>
                        <div style={{float: 'left',verticalAlign:'center'}}>
                            <span title={`${publish.build_date}  当前版本：${publish.version_name}`}>
                                <img style={{width:20,height:20,marginBottom:5,marginRight:5,marginLeft:3}} src={ic_clock} alt={'当前日期'}/></span>
                            <span id={'date'} className={'header-date-text-size'}
                                  title={'当前日期'}
                                  style={{textAlign: 'center', ...text_color}}>
                        </span>
                        </div>
                    </Col>
                    <Col>
                        <div style={{float: 'right', display: 'flex'}}>
                            <Row gutter={12} type="flex" align="middle" justify={"end"}>
                                <Col>
                                    {
                                        this.props.list.length && !this.props.channelFix?
                                            <Pagination
                                                className={'header-pagination-size v6-Pagination'}
                                                size={'small'}
                                                style={{color: '#FFFFFF'}}
                                                current={this.props.page}
                                                hideOnSinglePage={false}
                                                pageSize={this.props.grid[0] * this.props.grid[1]}
                                                defaultCurrent={1}
                                                total={this.props.total}
                                                onChange={this.props.onPageChange}
                                                showSizeChanger={false}
                                                onShowSizeChange={this.props.onPageChange}
                                                showQuickJumper={false}
                                                // showTotal={(total, range) => `${total} 条记录中的第 ${range[0]} 至 ${range[1]} 条`}
                                            /> : null
                                    }
                                </Col>
                                <Col>
                                <span
                                    // className={'header-setting-size'}
                                      title='刷新'
                                      style={{
                                          cursor: 'pointer',
                                          // border: '1px solid #FFFFFF'
                                      }} onClick={() => {
                                    window.location.reload(true);
                                }}>
                                    <img style={{width:45,height:23}} src={ic_refresh} alt={'刷新'}/>
                                </span>
                                </Col>
                                <Col>
                                <span
                                    // className={'header-setting-size'}
                                      title='设置'
                                      style={{
                                          cursor: 'pointer',
                                          // border: '1px solid #FFFFFF'
                                      }} onClick={this.showModal}>
                                    <img style={{width:45,height:23}} src={ic_setting} alt={'设置'}/>
                                </span>
                                </Col>
                                <Col>
                                 <span id={'fullScreenBtn'} title='全屏设置，若点击无效,请按键盘F11键开启/关闭全屏显示'
                                       style={{cursor: 'pointer'}} onClick={this.fullScreen}>
                                     {
                                         this.state.fullScreenState ?
                                             <img style={{width:45,height:23}} src={ic_fullscreen_close} alt={'关闭全屏'}/> :
                                             <img style={{width:45,height:23}} src={ic_fullscreen_open} alt={'开启全屏'}/>
                                     }
                                 </span>
                                </Col>
                                <Col>
                                    <UserCtrl userInfo={this.props.userInfo} homeStyleCode={this.props.homeStyleCode}/>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>

                <Drawer
                    width={Math.max(this.props.clientWidth * 0.382,650)}
                    title={<Typography.Text>参数设置</Typography.Text>}
                    headerStyle={{padding: '10px 10px'}}
                    bodyStyle={{paddingTop: '10px'}}
                    placement="right"
                    closable={false}
                    destroyOnClose={true}
                    visible={this.state.modalVisible}
                >
                    <BasicSettingWrapper
                        mngDept={this.props.mngDept}
                        setParams={this.props.setParams}
                        {...this.props}
                        onOK={this.hideModal}/>
                </Drawer>
            </div>
        )
    }


}

const mapStateToProps = (state) => {
    let userInfo = state.admin.userInfo;
    return {
        userInfo,
    }
}
export default withRouter(connect(mapStateToProps, null)(Tools6));
